import React from "react";
import Layout from "../../components/Layout";
import ImageWPlaceholder from "../../components/ImageWPlaceholder";
import RTF from "../../components/RTF";
import * as S from "./styles";
import { imageApi } from "../../helpers";
import { parse, format, isValid } from "date-fns";

const TwoColumns = ({ children }) => {
  return (
    <S.ColumnsContainer>
      <S.Left>{children[0]}</S.Left>
      <S.Right>{children[1]}</S.Right>
    </S.ColumnsContainer>
  );
};

const News = ({ news }) => {
  return (
    <Layout>
      <S.Title>News</S.Title>
      <div>
        {news.map((o, i) => {
          let image = imageApi(o.thumbnail, { fixWidth: 1200 });
          let date = parse(o.date, "yyyy-MM-dd", Date.now());
          return (
            <S.Post key={i}>
              <TwoColumns>
                <S.PostText>
                  <RTF>
                    <div>
                      {isValid(date) && (
                        <S.PostDate>
                          Posted on {format(date, "MMMM d, yyyy")}
                        </S.PostDate>
                      )}
                    </div>
                    {!o.hide_title && (
                      <div>
                        <S.PostTitle>{o.title}</S.PostTitle>
                      </div>
                    )}
                    <RTF dangerouslySetInnerHTML={{ __html: o.body }} />
                  </RTF>
                </S.PostText>
                <div>
                  <ImageWPlaceholder
                    width={image.width}
                    height={image.height}
                    src={image.src}
                  />
                </div>
              </TwoColumns>
            </S.Post>
          );
        })}
      </div>
    </Layout>
  );
};

export default News;
